import React, {Suspense, useContext, useEffect, useState} from "react";
import FilesView from "./FilesView";
import {BuilderProjectModel} from "@/src/models/project";
import {useParams} from "react-router-dom";
import {getProject} from "../../api/ProjectLoader";
import {WithLoggedInAuthInfoProps, withRequiredAuthInfo,} from "@propelauth/react";
import {CompanyType} from "../../models/company";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";
import {ProjectContext} from "../../contexts/ProjectContext";

const Drawings = (props: WithLoggedInAuthInfoProps) => {
    const [project, setProject] = useState<BuilderProjectModel | null>(null);
    const { project_id } = useParams<string>();
    const projectContext = useContext(ProjectContext);

    const fileContext = {
        context: "project",
        permission: "view",
        project_id: project_id,
        parent_id: project_id,
        parent_type: "project",
        folder_id: project?.root.id,
        editing: projectContext?.role === CompanyType.developer
    };

    useEffect(() => {
        if (project_id) {
            getProject(project_id, props.accessToken).then((data) => {
                setProject(data);
            });
        }
    }, [project_id]);

    if (!project) {
        return <div><BaseLoadingSpinner/></div>;
    }

    return (
        <div className="drawings">
            <br />
            {project ? <FilesView uploadContext={fileContext} /> : <Suspense />}
        </div>
    );
};

export default withRequiredAuthInfo(Drawings);
